export const API_URL = 'https://tozstudy.kr/rest';
export const SLIDE_INTRODUCE_SETTINGS = {
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  centerMode: false,
  variableWidth: true,
  useCSS: true
};